// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"dd4f85e7","4366":"9b524a2e"}[chunkId] + ".chunk.css";
};